import { PrivateSite } from '@wix/media-manager-sdk';
import { useMemo } from 'react';
import { MediaManagerSDKFile } from '../../../../typings/media-manager-sdk';
import { MediaType } from '../../../constants/MediaType';
import {
  MediaManagerAnyFolderId,
  VideoMakerPrivateMediaTag,
} from './usePrivateWixmp';

export const usePrivateSourceMethods = (mediaToken: string) => {
  const privateWixmpSource = new PrivateSite({
    siteMediaToken: mediaToken,
  });

  return useMemo(
    () => ({
      searchVideoMakerItems: () =>
        privateWixmpSource.items.searchByTag(VideoMakerPrivateMediaTag, {
          parentFolderId: MediaManagerAnyFolderId,
          mediaType: MediaType.Video,
        }),

      getDownloadLink: (fileId: string) =>
        privateWixmpSource.item.getDownloadUrl(fileId),

      deleteFile: (files: MediaManagerSDKFile[]) =>
        privateWixmpSource.items.remove(files),
      getFilesInfo: (fileIds: string[]) =>
        privateWixmpSource.items.get(fileIds),
    }),
    [privateWixmpSource],
  );
};
